<ion-buttons [ngClass]="{ 'no-borders': lines === 'none' }">
  <ion-button color="primary" (click)="onDecrease($event)" [disabled]="disabled || !quantity">
    <ion-icon *ngIf="lines !== 'none'" slot="icon-only" name="remove-circle-outline"></ion-icon>
    <ion-icon *ngIf="lines === 'none'" slot="icon-only" name="remove-outline"></ion-icon>
  </ion-button>
  <ion-input type="number" class="ion-text-center color-dark count" [value]="quantity" readonly disabled></ion-input>
  <ion-button color="primary" (click)="onIncrease($event)" [disabled]="disabled">
    <ion-icon *ngIf="lines !== 'none'" slot="icon-only" name="add-circle-outline"></ion-icon>
    <ion-icon *ngIf="lines === 'none'" slot="icon-only" name="add-outline"></ion-icon>
  </ion-button>
</ion-buttons>